import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router'
import { ApiError } from './api/client'
import { router } from './routes'
import { SessaoProvider } from './hooks/useSessao'
import { iniciarNativo } from './capacitor'
import './styles/index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // O catalogo muda por dia, nao por minuto.
      staleTime: 5 * 60_000,
      gcTime: 30 * 60_000,
      // Insistir num 404 ou num parametro invalido so gasta bateria.
      retry: (tentativas, erro) => {
        if (erro instanceof ApiError && ['NOT_FOUND', 'BAD_REQUEST'].includes(erro.code)) {
          return false
        }
        return tentativas < 2
      },
      // A WebView nativa dispara foco com frequencia demais.
      refetchOnWindowFocus: false,
    },
  },
})

void iniciarNativo()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessaoProvider>
        <RouterProvider router={router} />
      </SessaoProvider>
    </QueryClientProvider>
  </StrictMode>,
)
